import React from 'react';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';

class SimpleAlert extends React.Component{
    componentWillReceiveProps(nextProps){
        if(nextProps.showSuccess){
            Alert.success(nextProps.Msg,{
                onClose: nextProps.onClose()
            })
        }
        else if(nextProps.showError){
            Alert.error(nextProps.Msg,{
                onClose: nextProps.onClose()
            })
        }
    }
    render(){
        return(
            <Alert position={'top-right'} effect={'slide'} offset={100} timeout={5000} onShow={this.props.onShow} />
        )
    }
}
export default SimpleAlert;